import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Signup from './Signup';
import { useTranslation } from '../i18n';

interface SignupModalProps {
  show: boolean;
  onHide: () => void;
  onSignupSuccess?: () => void;
  hideCloseButton?: boolean;
}

const SignupModal: React.FC<SignupModalProps> = ({ 
  show, 
  onHide, 
  onSignupSuccess, 
  hideCloseButton = false
}) => {
  const { t } = useTranslation();
  const handleSignupSuccess = () => {
    if (onSignupSuccess) {
      onSignupSuccess();
    }
    onHide();
  };


  return (
    <Modal show={show} onHide={hideCloseButton ? undefined : onHide} centered size="lg">
      <Modal.Header closeButton={!hideCloseButton}>
        <Modal.Title>{t('auth.create_account')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Signup 
          onSignupSuccess={handleSignupSuccess}
        />
      </Modal.Body>
    </Modal>
  );
};

export default SignupModal;